import { Col, Row } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useEffect, useState } from "react";

const SingleBanner = ({
  TimeSlotDetails,
}: {
  TimeSlotDetails: any;
}): ReactElement => {
  const [getTimeSlotDetails, setTimeSlotDetails] = useState(undefined);

  useEffect(() => {
    setTimeSlotDetails(TimeSlotDetails);
  }, [TimeSlotDetails]);

  console.log("Details:", getTimeSlotDetails);

  return (
    <React.Fragment>
      <Row gutter={20}>
        <Col span={24}>
          <h3 className="title mt-4">Basic Information</h3>
          <div className="inner-body-wrapper">
            <div className="inner-body">
              <div className="single">
                <div className="info-name">
                  <span>Service Location</span>
                </div>
                <div className="info-desc">
                  <span>{getTimeSlotDetails?.serviceLocation}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Available Slot</span>
                </div>
                <div className="info-desc">
                  <span>{getTimeSlotDetails?.availableSlot}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Already Occupied</span>
                </div>
                <div className="info-desc">
                  <span>{getTimeSlotDetails?.alreadyOccupied}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Day</span>
                </div>
                <div className="info-desc">
                  <span>{getTimeSlotDetails?.day}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>From Hour</span>
                </div>
                <div className="info-desc">
                  <span>{getTimeSlotDetails?.fromHour}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>To Hour</span>
                </div>
                <div className="info-desc">
                  <span>{getTimeSlotDetails?.toHour}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Status</span>
                </div>
                <div className="info-desc">
                  <span
                    className={`radius-btn ${
                      getTimeSlotDetails?.isActive ? "active" : "inactive"
                    }-btn`}
                  >
                    {getTimeSlotDetails?.isActive ? "Active" : "Inactive"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
SingleBanner.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default SingleBanner;
